var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.galleryAdsGroup.length > 0 && !_vm.isMobile)?_c('ul',{staticClass:"gallery-ads"},_vm._l((_vm.galleryAdsGroup),function(ad,index){return _c('li',{staticClass:"gallery-ad--desktop",domProps:{"innerHTML":_vm._s(ad)}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }